import {
	HttpClient,
	HttpErrorResponse,
	HttpHeaders,
	HttpParams,
	HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
	OtpRequestCode,
	OtpRequestValidateCode,
} from 'src/app/models/apis/otp.model';
import { environment } from 'src/environments/environment';
import { HttpHeadersBuilder } from './utils/http-header-builder';

@Injectable({
	providedIn: 'root',
})
export class CmvfinanzasregistroService {
	urlBase = `${environment.urlBase}/onboarding/`;

	constructor(private _http: HttpClient) {}

	generateOtpTDC(data: OtpRequestCode): Observable<boolean> {
		const headers = new HttpHeadersBuilder()
			.withClientId()
			.withChannelId()
			.getHeaders();
		return this._http
			.post<HttpResponse<any>>(`${this.urlBase}getOtp`, data, {
				headers,
				observe: 'response',
			})
			.pipe(
				map((response: HttpResponse<any>) => {
					if (response.status === 200) {
						return true;
					}
					throw new Error(response.body.message);
				})
			);
	}

	validateOtpTDC(data: OtpRequestValidateCode) {
		const headers = new HttpHeadersBuilder()
			.withClientId()
			.withChannelId()
			.getHeaders();
		return this._http
			.post(`${this.urlBase}validaOTP`, data, {
				headers,
				observe: 'response',
			})
			.pipe(
				map((response: HttpResponse<any>) => {
					console.log('service', response);
					return {
						status: response.status === 200,
						body: response.body,
					};
				})
			);
	}
}
